import cn from 'classnames'
import { ReactNode, useCallback } from 'react'

import { IDataShape } from 'cng-common/components/treeSelect'
import { ITreeSelectProps } from 'cng-common/components/treeSelect/models/treeSelectProps'
import { useFormField } from 'cng-common/features/form'
import { GeoMappingWithOptions, IMappedGeoMappingItem } from 'partner360/components/filters'

import { IReportGeoChangeFnArgs } from './models'

import styles from './ReportGeo.module.scss'

interface IProps extends Pick<ITreeSelectProps<IDataShape>, 'typeOfSelectedNodes'> {
  options: IMappedGeoMappingItem[]
  geo: string[]
  field: string
  formKey: string
  label?: ReactNode
  onChange?: (args: IReportGeoChangeFnArgs) => void
  className?: string
}

export const ReportGeoWithOptions = ({
  options,
  geo,
  formKey,
  typeOfSelectedNodes,
  field,
  label,
  onChange,
  className,
}: IProps) => {
  const { value, handleChange } = useFormField<string[]>({
    defaultValue: geo,
    field: field,
    formKey: formKey,
  })

  const handleOnChange = useCallback(
    (displayedIds: string[], allSelectedIds: string[], onlyLeavesIds: string[]) => {
      onChange && onChange({ displayedIds, allSelectedIds, onlyLeavesIds })
      if (typeOfSelectedNodes === 'allSelectedItems') {
        handleChange(allSelectedIds)
        return
      }
      if (typeOfSelectedNodes === 'onlyLeavesItems') {
        handleChange(onlyLeavesIds)
        return
      }
      handleChange(displayedIds)
    },
    [handleChange, onChange, typeOfSelectedNodes]
  )

  return (
    <div className={cn(styles.root, className)}>
      <GeoMappingWithOptions
        options={options}
        className={styles.fields__field}
        values={value}
        label={label}
        onSelectChange={handleOnChange}
        typeOfSelectedNodes={typeOfSelectedNodes}
      />
    </div>
  )
}
